import { post } from './request'

export const AUTH_API_VISITOR_INIT = '/visitor/api/init/'
export const AUTH_API_REGISTER_USER = '/visitor/api/register_user/'
export const AUTH_API_LOGOUT = '/visitor/api/reset/'

export const initGoid = (data) => post(`${AUTH_API_VISITOR_INIT}`, data)
export const registerUser = (data) => post(`${AUTH_API_REGISTER_USER}`, data)
export const logout = (_goid) => post(`${AUTH_API_LOGOUT}`, { _goid })
